import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatCommonModule } from "@angular/material/core";
import {
	MAT_LEGACY_DIALOG_SCROLL_STRATEGY_PROVIDER as MAT_DIALOG_SCROLL_STRATEGY_PROVIDER,
	MatLegacyDialog as MatDialog,
	MatLegacyDialogActions as MatDialogActions,
	MatLegacyDialogClose as MatDialogClose,
	MatLegacyDialogConfig as MatDialogConfig,
	MatLegacyDialogContainer as MatDialogContainer,
	MatLegacyDialogContent as MatDialogContent,
	MatLegacyDialogTitle as MatDialogTitle,
} from "@angular/material/legacy-dialog";
import { MAT_SHEET_DEFAULT_OPTIONS, MatSideSheet } from "./mat-side-sheet";
import { MatSideSheetComponent } from "./mat-side-sheet.component";

@NgModule({
	imports: [OverlayModule, PortalModule, MatCommonModule],
	exports: [MatSideSheetComponent],
	declarations: [MatSideSheetComponent],
	providers: [
		MatSideSheet,
		MAT_DIALOG_SCROLL_STRATEGY_PROVIDER,
		{
			provide: MAT_SHEET_DEFAULT_OPTIONS,
			useValue: <MatDialogConfig>{
				height: "100%",
				maxHeight: "100%",
				panelClass: "mat-sheet-panel",
				hasBackdrop: true,
				position: {
					left: "0",
				},
			},
		},
	],
})
export class MatSideSheetModule {}
